import { defineComponent as N, ref as v, computed as T, watch as _, createElementBlock as l, openBlock as n, withKeys as g, createElementVNode as a, createBlock as k, createVNode as S, unref as c, withCtx as y, Fragment as B, renderList as E, createTextVNode as w, toDisplayString as b } from "vue";
import { useLoadingState as j, ScalarSearchInput as q, ScalarLoading as A, ScalarSearchResultList as D } from "@scalar/components";
import { useDebounceFn as F } from "@vueuse/core";
import { Client as H } from "typesense";
import { useRouter as Q } from "vue-router";
import z from "./TypesenseSearchResult.vue.js";
const O = { class: "guides-search-input" }, P = {
  key: 0,
  class: "guides-search-empty-state"
}, U = {
  key: 1,
  class: "guides-search-empty-state"
}, G = {
  key: 2,
  class: "guides-search-loading"
}, te = /* @__PURE__ */ N({
  __name: "TypesenseSearch",
  props: {
    typesenseKey: {},
    typesenseHost: {},
    typesenseCollection: {}
  },
  emits: ["close"],
  setup(L, { emit: C }) {
    const r = L, K = C, { resolve: V, push: $ } = Q(), x = {
      query_by: "page_content",
      highlight_affix_num_tokens: 6,
      per_page: 24
    }, p = j(), R = new H({
      apiKey: r.typesenseKey,
      // Be sure to use the search-only-api-key fo typesense
      nodes: [
        {
          host: r.typesenseHost,
          port: 443,
          protocol: "https"
        }
      ],
      connectionTimeoutSeconds: 2
    }), o = v([]), i = v(""), d = v(0), m = T(
      () => o.value[d.value]
    ), I = F(async (s) => {
      const e = await R.collections(r.typesenseCollection).documents().search({ q: s, ...x });
      p.stopLoading(), o.value = (e.hits || []).map((t) => {
        var u;
        return {
          ...t.document,
          uid: `search-result-${t.document.page_uid}`,
          snippet: (u = t.highlight.page_content) == null ? void 0 : u.snippet,
          route: V({
            name: t.document.page_uid,
            params: {
              project: t.document.project_uid,
              version: t.document.version_uid,
              guide: t.document.guide_uid
            }
          })
        };
      });
    }, 325);
    _(i, async (s) => {
      s && r.typesenseKey ? (p.startLoading(), I(s)) : o.value = [];
    }), _(m, (s) => {
      var e;
      !document || !s || (e = document.getElementById(s.uid)) == null || e.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    });
    function h(s) {
      const e = d.value, t = o.value.length;
      d.value = (e + t + s) % t;
    }
    function f(s) {
      m.value && ($(s ?? m.value.route), K("close"));
    }
    return (s, e) => (n(), l("div", {
      class: "guides-search",
      onKeydown: [
        e[1] || (e[1] = g((t) => h(1), ["down"])),
        e[2] || (e[2] = g((t) => f(), ["enter"])),
        e[3] || (e[3] = g((t) => h(-1), ["up"]))
      ]
    }, [
      a("div", O, [
        S(c(q), {
          modelValue: i.value,
          "onUpdate:modelValue": e[0] || (e[0] = (t) => i.value = t)
        }, null, 8, ["modelValue"])
      ]),
      s.typesenseKey ? i.value.length ? c(p).isLoading ? (n(), l("div", G, [
        S(c(A), {
          isLoading: "",
          size: "md"
        })
      ])) : (n(), k(c(D), {
        key: 3,
        class: "guides-search-results custom-scroll",
        noResults: !o.value.length
      }, {
        query: y(() => [
          w(b(i.value), 1)
        ]),
        default: y(() => [
          (n(!0), l(B, null, E(o.value, (t, u) => (n(), k(z, {
            id: t.uid,
            key: `${u}${t.page_uid}`,
            active: d.value === u,
            snippet: t.snippet,
            onClick: (J) => f(t.route)
          }, {
            default: y(() => [
              w(b(t.page_title), 1)
            ]),
            _: 2
          }, 1032, ["id", "active", "snippet", "onClick"]))), 128))
        ]),
        _: 1
      }, 8, ["noResults"])) : (n(), l("div", U, e[5] || (e[5] = [
        a("div", null, "Type Query Above", -1)
      ]))) : (n(), l("div", P, e[4] || (e[4] = [
        a("div", null, " On your published sites your content will be fully searchable allowing users to move around your documents with ease ✨ ", -1)
      ]))),
      e[6] || (e[6] = a("div", { class: "guides-search-meta" }, [
        a("span", null, "↑↓ Navigate"),
        a("span", null, "⏎ Select")
      ], -1))
    ], 32));
  }
});
export {
  te as default
};
